// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2WMsL","signatureBlock":"Footer_signatureBlock__1sPs-","signature":"Footer_signature__2B4nA"};